import dayjs from 'dayjs'

import Head from 'next/head'
import Link from 'next/link'
import Image from 'next/image'

import Prismic from '@prismicio/client'
import { RichText } from 'prismic-reactjs'

import Button from '../../components/base/Button'
import GetStarted from '../../components/GetStarted'

import { Client } from '../../utils/prismicHelpers'

import Subscribe from '../../components/Subscribe'

const InsightsPage = ({ page, posts, more }) => {
    const metaTitle = `Newsworthy articles on AI & Machine Learning | Page ${page} | ${process.env.NEXT_PUBLIC_APP_NAME} `

    const metaDescription =
        'Discover and learn about practical approaches of Artificial Intelligence, Machine Learning & Data Science to transform your business for better future.'

    const metaImage =
        process.env.NEXT_PUBLIC_APP_URL + '/og-images/og-images_insights.jpg'
    return (
        <>
            <Head>
                {process.browser ? (
                    <title>{metaTitle}</title>
                ) : (
                    <title
                        dangerouslySetInnerHTML={{ __html: metaTitle }}
                    ></title>
                )}
                <meta name="description" content={metaDescription} />
                <meta property="og:title" content={metaTitle} />
                <meta name="og:description" content={metaDescription} />
                <meta property="og:image" content={metaImage} />
                <meta
                    property="og:url"
                    content={`${process.env.NEXT_PUBLIC_APP_URL}/insights`}
                />
                <meta name="twitter:title" content={metaTitle} />
                <meta name="twitter:description" content={metaDescription} />
                <meta name="twitter:image" content={metaImage} />
            </Head>
            <div>
                {/* Banner */}
                <div
                    className="banner insights"
                    style={{
                        backgroundImage: `url("/insights/banner-bg.png")`,
                    }}
                >
                    <div className="inner">
                        <span className="tagline">INSIGHTS</span>
                        <h1>
                            Newsworthy articles on the latest tech news, trends,
                            and commentary delivered to your inbox.
                        </h1>
                        <div>
                            <Subscribe signup={false} />
                        </div>
                    </div>
                </div>
                {/* Post */}
                <div className="section">
                    <div className="max-w-[640px] mx-auto tablet:w-full tablet:px-6">
                        {posts.map((post) => (
                            <div
                                key={post.uid}
                                className="pb-10 mb-10 border-b insights-block border-interface-200"
                            >
                                <Link
                                    href={{
                                        pathname: '/insights/[id]',
                                        query: {
                                            id: post.uid,
                                        },
                                    }}
                                >
                                    <a>
                                        <h2 className="mb-3 text-3xl text-primary-900">
                                            {RichText.asText(post.data.title)}
                                        </h2>
                                        <span className="block mb-6 text-sm font-normal text-interface-700">
                                            {dayjs(post.data.post_date).format(
                                                'MMMM D, YYYY'
                                            )}
                                        </span>
                                        <div className="mb-6 overflow-hidden rounded-xl">
                                            <Image
                                                className="mb-6"
                                                src={post.data.main_image.url}
                                                alt={post.data.main_image.alt}
                                                layout="responsive"
                                                width={
                                                    post.data.main_image
                                                        .dimensions.width
                                                }
                                                height={
                                                    post.data.main_image
                                                        .dimensions.height
                                                }
                                            />
                                        </div>
                                        <p className="text-lg text-interface-900">
                                            {RichText.asText(post.data.excerpt)}
                                        </p>
                                    </a>
                                </Link>
                            </div>
                        ))}
                        <div>
                            <div className="flex">
                                {page > 1 && (
                                    <div className="mr-4">
                                        <Button
                                            text="Previous"
                                            type="button"
                                            variant="secondary"
                                            link={{
                                                pathname: '/insights/',
                                                query: {
                                                    page: page - 1,
                                                },
                                            }}
                                        />
                                    </div>
                                )}
                                {more && (
                                    <div>
                                        <Button
                                            text="Next"
                                            type="button"
                                            variant="primary"
                                            link={{
                                                pathname: '/insights/',
                                                query: {
                                                    page: page + 1,
                                                },
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Get started */}
                <GetStarted blueVariant />
            </div>
        </>
    )
}

InsightsPage.getInitialProps = async ({ query }) => {
    const response = await Client().query(
        Prismic.Predicates.at('document.type', 'posts'),
        {
            lang: '*',
            pageSize: 5,
            page: query.page,
        }
    )

    return {
        page: response.page,
        posts: response.results,
        more: response.page < response.total_pages,
    }
}

export default InsightsPage
